module.exports = __webpack_public_path__ + "static/img/logo.25fbf75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/CUIABA/logo.png
// module id = f8V1
// module chunks = 1